export const getters = {
	investmentProducts: state => state.investment_products
}



// WEBPACK FOOTER //
// ./src/common/store/Investment/getters.js